export default "__VITE_ASSET__67a4fd1c__"